export default __webpack_public_path__ + "static/media/ride.44e63854.wav";